import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-waterfall',
  templateUrl: './waterfall.component.html',
  styleUrls: ['./waterfall.component.scss']
})
export class WaterfallComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
